module.exports = __webpack_public_path__ + "img/penilaian-buku-rekomendasi.f2bd40f1.jpeg";